var player = document.getElementById('flat-black-player-container');
if(player !== null) {
  window.onkeydown = function(e) {
      return !(e.keyCode == 32);
  };

  /*
    Handles a click on the down button to slide down the playlist.
  */
  document.getElementsByClassName('down-header')[0].addEventListener('click', function(){
    var list = document.getElementById('list');

    list.style.height = ( parseInt( document.getElementById('flat-black-player-container').offsetHeight ) - 135 ) + 'px';

    document.getElementById('list-screen').classList.remove('slide-out-top');
    document.getElementById('list-screen').classList.add('slide-in-top');
    document.getElementById('list-screen').style.display = "block";
  });

  /*
    Handles a click on the up arrow to hide the list screen.
  */
  document.getElementsByClassName('hide-playlist')[0].addEventListener('click', function(){
    document.getElementById('list-screen').classList.remove('slide-in-top');
    document.getElementById('list-screen').classList.add('slide-out-top');
    document.getElementById('list-screen').style.display = "none";
  });

  /*
    Handles a click on the song played progress bar.
  */
  document.getElementById('song-played-progress').addEventListener('click', function( e ){
    var offset = this.getBoundingClientRect();
    var x = e.pageX - offset.left;

    Amplitude.setSongPlayedPercentage( ( parseFloat( x ) / parseFloat( this.offsetWidth) ) * 100 );
  });

  document.querySelector('img[data-amplitude-song-info="cover_art_url"]').style.height = document.querySelector('img[data-amplitude-song-info="cover_art_url"]').offsetWidth + 'px';
 
  var songs = new Array();
  var continue_loop = true;
  var count = 1;
  while(continue_loop) {
    var name = document.getElementById('af-name-'+count);
    if(name !== 'null' && name !== null) {
      var artist = document.getElementById('af-artist-'+count).textContent;
      var album = document.getElementById('af-album-'+count).textContent;
      var url = document.getElementById('af-url-'+count).textContent;
      var cover_art_url = document.getElementById('af-cover_art-'+count).textContent;
      songs.push({"name":name.textContent, "artist":artist, "album":album, "url":url, "cover_art_url":cover_art_url});
    }
    else {
      continue_loop = false;  
    }
    count++;
  }
  Amplitude.init({
    "bindings": {
      37: 'prev',
      39: 'next',
      32: 'play_pause'
    },
    "songs": songs
  });
}

function topFunction() {
  document.body.scrollTop = 0; // For Safari
  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
}

jQuery(document).ready(function($){

	// get params
  
    $('.salutation').hide();

	const query_string = window.location.search;
	const params = new URLSearchParams(query_string);
	var first_name = params.get('inf_field_FirstName');
  	if(first_name !== null && first_name !== '') {
		$('.first-name').html(first_name);
      	$('.salutation').show();
    }
});